import { deleteConversationApiConversationsSessionIdDelete } from "@noa/api-core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reportError } from "../../typed-client";
import { ApiError } from "../../errors";
import { ConversationQueryKey } from "../../query-keys";

const deleteConversationRequest = async (sessionId: string) => {
  await deleteConversationApiConversationsSessionIdDelete({
    path: { session_id: sessionId },
    throwOnError: true,
  });
};

export const useDeleteConversation = () => {
  const queryClient = useQueryClient();
  return useMutation<void, ApiError, string>({
    mutationFn: deleteConversationRequest,
    onError: reportError,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ConversationQueryKey.all });
    },
  });
};
